// Indonesian Translations
const id = {
  // Common
  common: {
    calculate: 'Hitung',
    copy: 'Salin',
    download: 'Download',
    compare: 'Bandingkan',
    reset: 'Reset',
    close: 'Tutup',
    cancel: 'Batal',
    save: 'Simpan',
    year: 'tahun',
    years: 'tahun',
    month: 'bulan',
    months: 'bulan',
    currency: 'Rp',
    percent: '%',
    required: 'Wajib diisi',
    invalid: 'Tidak valid',
    success: 'Berhasil',
    error: 'Terjadi kesalahan',
    loading: 'Memuat...',
    relatedCalculators: 'Kalkulator Terkait',
    viewAll: 'Lihat Semua'
  },
  
  // Navigation
  nav: {
    home: 'Beranda',
    calculators: 'Kalkulator',
    kpr: 'Simulasi KPR',
    investment: 'Investasi',
    emergencyFund: 'Dana Darurat',
    aiBudget: 'AI Budget',
    insurance: 'Asuransi',
    blog: 'Blog',
    admin: 'Admin'
  },
  
  // Homepage
  home: {
    title: 'Kalkulator Keuangan Online Gratis',
    subtitle: 'Hitung KPR, investasi, dana darurat, dan AI budget planner secara gratis dan cepat.',
    heroTitle: 'Rencanakan Keuangan Anda dengan Mudah',
    heroSubtitle: 'Platform kalkulator keuangan terlengkap di Indonesia',
    ctaButton: 'Mulai Sekarang',
    features: {
      title: 'Fitur Unggulan',
      kpr: 'Simulasi KPR dengan bunga bertahap',
      investment: 'Kalkulator investasi compound interest',
      emergency: 'Perencanaan dana darurat',
      ai: 'AI Budget Planner pintar'
    }
  },
  
  // KPR Calculator
  kpr: {
    title: 'Kalkulator KPR Online',
    subtitle: 'Simulasi Cicilan Rumah Akurat',
    description: 'Hitung cicilan KPR dengan bunga bertahap, DP fleksibel, dan tenor hingga 30 tahun.',
    propertyPrice: 'Harga Properti',
    downPayment: 'Down Payment',
    tenor: 'Total Tenor',
    interestRate: 'Bunga',
    fixedPeriod: 'Periode Fixed',
    floatingRate: 'Bunga Floating',
    monthlyPayment: 'Cicilan Bulanan',
    totalPayment: 'Total Pembayaran',
    totalInterest: 'Total Bunga',
    loanAmount: 'Jumlah Pinjaman',
    calculateButton: 'Hitung Cicilan KPR',
    compareButton: 'Compare KPR',
    stages: 'Tahapan Bunga',
    fixedStage: 'Fix Tahap',
    floatingStage: 'Floating',
    duration: 'Durasi',
    remaining: 'sisa otomatis',
    tips: {
      title: 'Tips Memilih KPR',
      tip1: 'Bandingkan total bunga, bukan hanya promo awal',
      tip2: 'Siapkan dana untuk kenaikan cicilan saat floating',
      tip3: 'Pertimbangkan pelunasan dipercepat',
      tip4: 'Hitung kemampuan cicilan max 30% gaji'
    }
  },
  
  // Investment Calculator
  investment: {
    title: 'Kalkulator Investasi',
    subtitle: 'Simulasi Return Compounding',
    description: 'Simulasi pertumbuhan investasi dengan berbagai instrumen dan skenario risiko.',
    initialAmount: 'Modal Awal',
    monthlyContribution: 'Kontribusi Bulanan',
    annualReturn: 'Return Tahunan',
    investmentPeriod: 'Jangka Waktu',
    finalValue: 'Nilai Akhir',
    totalInvested: 'Total Investasi',
    totalReturn: 'Total Return',
    calculateButton: 'Hitung Investasi',
    simpleMode: 'Simple',
    advancedMode: 'Advanced',
    aiRecommendation: 'Gunakan AI Rekomendasi',
    instruments: {
      deposito: 'Deposito',
      obligasi: 'Obligasi',
      reksadana_pasar_uang: 'Reksadana Pasar Uang',
      reksadana_pendapatan_tetap: 'Reksadana Pendapatan Tetap',
      reksadana_campuran: 'Reksadana Campuran',
      reksadana_saham: 'Reksadana Saham',
      saham: 'Saham',
      emas: 'Emas',
      crypto: 'Crypto'
    },
    tips: {
      title: 'Tips Investasi',
      tip1: 'Mulai investasi sedini mungkin',
      tip2: 'Konsisten menambah investasi bulanan',
      tip3: 'Diversifikasi portfolio Anda',
      tip4: 'Pilih instrumen sesuai profil risiko'
    }
  },
  
  // Emergency Fund Calculator
  emergencyFund: {
    title: 'Kalkulator Dana Darurat',
    subtitle: 'Hitung Target Keuangan Anda',
    description: 'Hitung berapa dana darurat ideal sesuai pengeluaran bulanan Anda.',
    monthlyExpenses: 'Pengeluaran Bulanan',
    monthlyDebt: 'Cicilan Bulanan',
    dependents: 'Jumlah Tanggungan',
    employmentType: 'Tipe Pekerjaan',
    existingFund: 'Dana Darurat Saat Ini',
    targetFund: 'Target Dana Darurat',
    monthlyTarget: 'Target Tabungan/Bulan',
    timeToGoal: 'Waktu Tercapai',
    calculateButton: 'Hitung Rencana Dana Darurat',
    employmentTypes: {
      employee: 'Karyawan',
      freelancer: 'Freelancer',
      business_owner: 'Pemilik Bisnis'
    },
    tips: {
      title: 'Tips Menyimpan Dana Darurat',
      tip1: 'Simpan di rekening terpisah',
      tip2: 'Pilih instrumen yang likuid',
      tip3: 'Jangan dipakai untuk investasi berisiko',
      tip4: 'Review kebutuhan setiap 6 bulan',
      tip5: 'Otomatis transfer setiap gajian'
    }
  },
  
  // AI Budget Planner
  aiBudget: {
    title: 'AI Budget Planner',
    subtitle: 'Rencana Keuangan Otomatis',
    description: 'Gunakan AI untuk menyusun anggaran bulanan berdasarkan profil keuangan Anda.',
    monthlyIncome: 'Pendapatan Bulanan',
    city: 'Kota Tinggal',
    rentMortgage: 'Biaya Sewa/KPR',
    existingDebt: 'Cicilan Hutang',
    generateButton: 'Buat Budget dengan AI',
    recommendation: 'Rekomendasi AI',
    allocation: 'Alokasi Budget',
    tips: {
      title: 'Tips Mengatur Budget',
      tip1: 'Prioritaskan kebutuhan dasar',
      tip2: 'Sisihkan minimal 20% untuk tabungan',
      tip3: 'Review budget setiap bulan',
      tip4: 'Gunakan sistem amplop digital'
    }
  },
  
  // Insurance Calculator
  insurance: {
    title: 'Kalkulator Asuransi Jiwa',
    subtitle: 'Estimasi Kebutuhan Proteksi',
    description: 'Estimasi kebutuhan asuransi jiwa yang ideal untuk melindungi keluarga Anda.',
    age: 'Usia Saat Ini',
    annualIncome: 'Penghasilan Tahunan',
    dependents: 'Jumlah Tanggungan',
    existingDebt: 'Hutang yang Ada',
    coverageAmount: 'Uang Pertanggungan',
    termSuggestion: 'Masa Pertanggungan',
    premiumEstimate: 'Estimasi Premi Bulanan',
    calculateButton: 'Hitung Kebutuhan Asuransi',
    tips: {
      title: 'Tips Memilih Asuransi',
      tip1: 'Pilih term life untuk proteksi murni',
      tip2: 'Baca polis dengan teliti',
      tip3: 'Pastikan perusahaan bereputasi baik',
      tip4: 'Review kebutuhan setiap 3-5 tahun'
    }
  },
  
  // Lead Capture
  leadCapture: {
    title: 'Isi Data Berikut',
    subtitle: 'untuk melanjutkan',
    name: 'Nama Lengkap',
    email: 'Email',
    phone: 'Nomor HP',
    noSpam: 'Tenang aja, kita nggak akan spam kok.',
    copyNow: 'Salin Sekarang',
    downloadNow: 'Download Sekarang',
    processing: 'Memproses...',
    successMessage: 'Data berhasil disimpan!'
  },
  
  // Footer
  footer: {
    description: 'Platform kalkulator keuangan terlengkap di Indonesia untuk membantu perencanaan keuangan Anda.',
    calculators: 'Kalkulator',
    resources: 'Resources',
    company: 'Perusahaan',
    about: 'Tentang Kami',
    contact: 'Kontak',
    privacy: 'Kebijakan Privasi',
    terms: 'Syarat & Ketentuan',
    copyright: '© 2025 KalkulatorDuit. Semua hak dilindungi.',
    poweredBy: 'Powered by Wealthify'
  },
  
  // SEO Content
  seo: {
    kpr: {
      title: 'Panduan Lengkap Kalkulator KPR',
      intro: 'Kredit Pemilikan Rumah (KPR) adalah fasilitas pinjaman dari bank untuk membeli rumah. Memahami cicilan KPR sangat penting sebelum mengambil keputusan.',
      howItWorks: 'Cara Kerja Kalkulator KPR',
      howItWorksDesc: 'Kalkulator KPR kami menghitung cicilan bulanan menggunakan metode anuitas dengan mempertimbangkan bunga bertahap (fixed dan floating).',
      whyUse: 'Mengapa Menggunakan Kalkulator KPR?',
      benefits: [
        'Simulasi akurat dengan bunga bertahap',
        'Bandingkan skenario DP berbeda',
        'Persiapkan kenaikan cicilan saat floating',
        'Download hasil untuk perbandingan bank'
      ],
      faq: [
        { q: 'Berapa ideal DP untuk KPR?', a: 'Idealnya 20-30% dari harga properti. DP lebih besar berarti cicilan lebih ringan.' },
        { q: 'Apa bedanya bunga fixed dan floating?', a: 'Fixed artinya bunga tetap selama periode tertentu, floating mengikuti suku bunga pasar.' },
        { q: 'Berapa maksimal tenor KPR?', a: 'Umumnya maksimal 20-25 tahun, tergantung usia dan kebijakan bank.' }
      ]
    },
    investment: {
      title: 'Panduan Kalkulator Investasi',
      intro: 'Investasi adalah cara terbaik untuk mengembangkan kekayaan jangka panjang. Kalkulator investasi membantu Anda memproyeksikan pertumbuhan dana.',
      howItWorks: 'Cara Kerja Compound Interest',
      howItWorksDesc: 'Bunga majemuk (compound interest) bekerja dengan menginvestasikan kembali keuntungan, sehingga keuntungan Anda juga menghasilkan keuntungan.',
      whyUse: 'Manfaat Simulasi Investasi',
      benefits: [
        'Proyeksi realistis dengan return historis',
        'Bandingkan berbagai instrumen investasi',
        'Pahami dampak investasi rutin bulanan',
        'Tentukan target keuangan jangka panjang'
      ],
      faq: [
        { q: 'Berapa return investasi yang realistis?', a: 'Deposito 4-6%, reksadana pasar uang 5-7%, saham 10-15% per tahun (historis).' },
        { q: 'Kapan waktu terbaik untuk mulai investasi?', a: 'Sekarang! Semakin awal memulai, semakin besar manfaat compound interest.' },
        { q: 'Apakah investasi aman?', a: 'Setiap investasi memiliki risiko. Pilih instrumen sesuai profil risiko Anda.' }
      ]
    },
    emergencyFund: {
      title: 'Panduan Dana Darurat',
      intro: 'Dana darurat adalah tabungan yang disisihkan untuk keadaan tidak terduga seperti kehilangan pekerjaan atau biaya medis.',
      howItWorks: 'Cara Menghitung Dana Darurat',
      howItWorksDesc: 'Besaran dana darurat dihitung berdasarkan pengeluaran bulanan dikalikan jumlah bulan coverage yang dibutuhkan.',
      whyUse: 'Mengapa Dana Darurat Penting?',
      benefits: [
        'Perlindungan dari kejadian tak terduga',
        'Menghindari utang saat darurat',
        'Ketenangan pikiran finansial',
        'Fondasi perencanaan keuangan yang solid'
      ],
      faq: [
        { q: 'Berapa ideal dana darurat?', a: '6 bulan pengeluaran untuk karyawan, 9-12 bulan untuk freelancer atau business owner.' },
        { q: 'Di mana menyimpan dana darurat?', a: 'Rekening tabungan atau deposito yang mudah dicairkan.' },
        { q: 'Apakah boleh diinvestasikan?', a: 'Tidak disarankan. Dana darurat harus likuid dan aman.' }
      ]
    },
    aiBudget: {
      title: 'Panduan AI Budget Planner',
      intro: 'AI Budget Planner membantu Anda membuat rencana keuangan bulanan yang cerdas dan personal.',
      howItWorks: 'Cara Kerja AI Budget Planner',
      howItWorksDesc: 'AI menganalisis pendapatan, pengeluaran wajib, dan tujuan finansial Anda untuk memberikan rekomendasi alokasi budget yang optimal.',
      whyUse: 'Keunggulan Budgeting dengan AI',
      benefits: [
        'Rekomendasi budget yang personal',
        'Menyesuaikan dengan biaya hidup kota Anda',
        'Optimasi tabungan dan investasi',
        'Saran yang mudah diterapkan'
      ],
      faq: [
        { q: 'Apa itu metode 50/30/20?', a: 'Metode populer: 50% kebutuhan, 30% keinginan, 20% tabungan/investasi. AI menyesuaikan berdasarkan kondisi Anda.' },
        { q: 'Bagaimana cara memulai budgeting?', a: 'Catat semua pemasukan dan pengeluaran bulanan, lalu gunakan AI Budget Planner untuk mendapat rekomendasi.' },
        { q: 'Apakah hasil AI akurat?', a: 'AI memberikan rekomendasi berdasarkan best practices keuangan, disesuaikan dengan data yang Anda masukkan.' }
      ]
    },
    insurance: {
      title: 'Panduan Kalkulator Asuransi',
      intro: 'Asuransi jiwa memberikan proteksi finansial untuk keluarga jika terjadi hal yang tidak diinginkan.',
      howItWorks: 'Cara Menghitung Kebutuhan Asuransi',
      howItWorksDesc: 'Kebutuhan asuransi dihitung berdasarkan pendapatan tahunan, jumlah tanggungan, dan hutang yang harus ditanggung.',
      whyUse: 'Pentingnya Asuransi Jiwa',
      benefits: [
        'Proteksi keluarga dari risiko finansial',
        'Coverage yang sesuai kebutuhan',
        'Perencanaan warisan yang baik',
        'Ketenangan pikiran'
      ],
      faq: [
        { q: 'Berapa coverage asuransi yang ideal?', a: 'Umumnya 5-10x pendapatan tahunan, tergantung jumlah tanggungan dan hutang.' },
        { q: 'Kapan sebaiknya membeli asuransi jiwa?', a: 'Semakin muda semakin baik karena premi lebih murah dan risiko ditolak lebih kecil.' },
        { q: 'Apa bedanya asuransi term dan whole life?', a: 'Term memberikan proteksi untuk periode tertentu (lebih murah), whole life memberikan proteksi seumur hidup.' }
      ]
    }
  },

  // SEO Content Blocks for each page (800-1200 characters) - AI Financial Tools Focus
  seoContent: {
    home: {
      title: 'Perencana Keuangan Berbasis AI',
      content: 'KalkulatorDuit menyediakan tools perencana keuangan berbasis AI yang gratis dan akurat. Platform kami menggunakan teknologi artificial intelligence untuk membantu Anda membuat keputusan finansial yang cerdas. Dari simulasi KPR dengan bunga bertahap hingga kalkulator investasi dengan profil risiko otomatis, semua tools kami dirancang untuk memberikan hasil yang personal dan relevan. Bergabung dengan ribuan pengguna yang mempercayakan perencanaan keuangan mereka pada tools AI kami.'
    },
    kpr: {
      title: 'Simulasi KPR Cerdas dengan AI',
      content: 'Kalkulator KPR berbasis AI kami memberikan simulasi cicilan yang akurat dengan mempertimbangkan bunga bertahap. Fitur perbandingan skenario cerdas membantu Anda menganalisis berbagai opsi DP dan tenor secara berdampingan. Sistem AI kami mengidentifikasi skenario paling hemat secara otomatis. Cocok untuk pembeli rumah pertama maupun investor properti yang ingin membuat keputusan berdasarkan data. Dapatkan insight instan tentang total bunga dan variasi cicilan sepanjang masa pinjaman.'
    },
    investment: {
      title: 'Simulator Investasi Berbasis AI',
      content: 'Rasakan perencanaan investasi cerdas dengan kalkulator berbasis AI kami. Algoritma canggih mensimulasikan pertumbuhan compound interest di berbagai instrumen termasuk saham, reksadana, dan obligasi. AI profiler risiko bawaan menganalisis tujuan finansial dan toleransi risiko Anda untuk merekomendasikan alokasi portofolio optimal. Visualisasikan trajektori pertumbuhan kekayaan Anda dan buat keputusan investasi lebih cerdas dengan teknologi AI.'
    },
    emergencyFund: {
      title: 'Perencana Dana Darurat Cerdas',
      content: 'Kalkulator dana darurat berbasis AI kami mempertimbangkan situasi unik Anda untuk merekomendasikan target yang ideal. AI menganalisis tipe pekerjaan, tanggungan, dan pengeluaran bulanan untuk menghitung target coverage yang personal. Pantau progress dengan indikator visual dan dapatkan rencana tabungan yang actionable. Baik Anda karyawan, freelancer, atau business owner, tools cerdas kami memastikan Anda siap menghadapi ketidakpastian finansial.'
    },
    aiBudget: {
      title: 'AI Budget Planner - Asisten Keuangan Pintar',
      content: 'Biarkan artificial intelligence mentransformasi cara Anda budgeting. AI Budget Planner kami menganalisis pendapatan, pengeluaran, dan tujuan finansial untuk membuat rekomendasi yang personal. Sistem cerdas mempertimbangkan biaya hidup di kota Anda dan menyarankan alokasi optimal untuk kebutuhan, keinginan, dan tabungan. Dapatkan indikator kesehatan finansial real-time dan saran yang bisa langsung diterapkan. Stop menebak-nebak budget Anda - biarkan AI membimbing Anda menuju kesejahteraan finansial.'
    },
    insurance: {
      title: 'Kalkulator Asuransi Berbasis AI',
      content: 'Tentukan coverage asuransi jiwa ideal dengan kalkulator cerdas kami. AI mempertimbangkan pendapatan, tanggungan, dan hutang untuk merekomendasikan level proteksi yang sesuai. Tools pintar kami membantu Anda memahami dampak finansial pada keluarga dan menyarankan masa pertanggungan optimal. Bandingkan estimasi premi dan buat keputusan proteksi yang informed. Dapatkan insight asuransi yang personal tanpa kerumitan kalkulator tradisional.'
    }
  },

  // Metadata for SEO
  meta: {
    home: {
      title: 'Kalkulator Keuangan Gratis + AI Finance Tools | KalkulatorDuit',
      description: 'Kalkulator keuangan gratis untuk simulasi KPR, investasi, budget bulanan, dan tools AI yang membantu Anda membuat keputusan finansial lebih cerdas.'
    },
    kpr: {
      title: 'Kalkulator KPR Berbasis AI - Simulasi Cicilan Rumah Cerdas | KalkulatorDuit',
      description: 'Hitung cicilan KPR dengan simulasi bunga bertahap berbasis AI. Bandingkan skenario, rencanakan bunga floating, dan buat keputusan pembelian rumah yang cerdas.'
    },
    investment: {
      title: 'Kalkulator Investasi AI - Simulator Pertumbuhan Portofolio | KalkulatorDuit',
      description: 'Simulasi pertumbuhan investasi dengan AI risk profiling. Hitung return compound, bandingkan instrumen, dan dapatkan rekomendasi portofolio personal.'
    },
    emergencyFund: {
      title: 'Kalkulator Dana Darurat Cerdas - Perencana Finansial AI | KalkulatorDuit',
      description: 'Hitung dana darurat ideal dengan analisis berbasis AI. Target personal berdasarkan tipe pekerjaan, pengeluaran, dan tanggungan.'
    },
    aiBudget: {
      title: 'AI Budget Planner - Asisten Perencanaan Keuangan Cerdas | KalkulatorDuit',
      description: 'Buat budget personal dengan AI. Rekomendasi alokasi cerdas, indikator kesehatan finansial real-time, dan saran tabungan yang actionable.'
    },
    insurance: {
      title: 'Kalkulator Asuransi Jiwa AI - Estimator Coverage Cerdas | KalkulatorDuit',
      description: 'Estimasi kebutuhan asuransi jiwa dengan analisis AI. Rekomendasi personal berdasarkan pendapatan, tanggungan, dan tujuan finansial.'
    }
  }
};

export default id;
